module.exports = __webpack_public_path__ + "static/service-inspections-cfb6f6bed21705bf365d251e2ec2f895.jpg";